import { setScrolled } from 'helpers/navHelpers';
import React from 'react';

import {
	Logo,
	LogoContainer,
	NavContainer,
	Wrapper,
} from './styles';

const Navbar = ({
	solid=false, ...props
}) => {
	return (
		<Wrapper>
			<NavContainer
				scrolled={setScrolled()}
				solid={solid}
			>
				<LogoContainer>
					<a href="/yd/patient/dashboard/">
						<Logo />
					</a>
				</LogoContainer>
			</NavContainer>
		</Wrapper>
	);
};

export default Navbar;
